import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionWidget, QuickLinks, Hero } from '../blocks/all-blocks';
import '../styles/home.css';

const Home = () => {
  const { t } = useTranslation();
  const [displayMethod, setDisplayMethod] = useState(true);

  const recentNine = [];

  const quickLinks = [
    { name: t('quickLinks.knowledge'), url: '/knowledge' },
    { name: t('quickLinks.tools'), url: '/tools' },
    { name: t('quickLinks.aboutMe'), url: '/me' }
  ];

  return (
    <div className="cont-body">
      <Hero forFrontPage={true} translation='hero'/>
      <SectionWidget forFrontPage={true} sectionName={t('recentNotes')} recentNine={recentNine} url='/notes' displayMethod={displayMethod} setDisplayMethod={setDisplayMethod} />
      <SectionWidget forFrontPage={true} sectionName={t('recentCreations')} recentNine={recentNine} url='/creations' displayMethod={displayMethod} setDisplayMethod={setDisplayMethod} />
      <SectionWidget forFrontPage={true} sectionName={t('popularTravelGuides')} recentNine={recentNine} url='/travel' displayMethod={displayMethod} setDisplayMethod={setDisplayMethod} />
      <QuickLinks list={quickLinks} />
    </div>
  );
};

export default Home;
